// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// styles
import { Container, Title } from './styles';

// defs
interface TagProps {
  item: Listing.IProductTag;
  className: string;
}

function Tag({ item, className }: TagProps) {
  if (isEmpty(item)) return null;
  const { title, titleColor, bgColor, borderColor, transparency_web } = item;
  return (
    <Container
      bgColor={bgColor}
      borderColor={borderColor}
      transparency_web={transparency_web}
      className={className}
    >
      <Title titleColor={titleColor}>{title}</Title>
    </Container>
  );
}

export default memo(Tag);
